<template>
    <div>
        <v-dialog v-model="ratingdialog" max-width="900px">
          <v-card>
            <v-card-title>
                {{$t('performancemanagement.editkpiprogress')}}
                <span class="pl-2">{{reviewdate}}</span>
            </v-card-title>
            <v-card-text class="pt-4">
              <v-container>

                    <div>
                        <div class="mr-3">
                            <v-row class="pb-n5 mt-4">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    type="text"
                                    v-model="indKpiData.goal"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n4">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.KPI')"
                                    type="text"
                                    v-model="indKpiData.kpi"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n7">
                                <v-col cols="6" class="mx-0">
                                    <v-row>
                                        <v-col v-if="indKpiData.threshold != null"  cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.threshold')"
                                                type="number"
                                                v-model="indKpiData.threshold"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('columns.target')"
                                                type="number"
                                                v-model="indKpiData.target"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="indKpiData.stretch != null"  cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.stretch')"
                                                type="number"
                                                v-model="indKpiData.stretch"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n7">
                                <v-col cols="4" class="pl-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.reviewdate')"
                                        type="date"
                                        :rules="[rules.required]"
                                        v-model="formData.reviewdate"
                                        dense
                                        class="v-input"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.achievement')"
                                        type="number"
                                        :rules="[rules.required]"
                                        v-model="formData.achievement"
                                        dense
                                        class="v-input"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n7">
                                <v-autocomplete
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.reviewedby')"
                                    type="text"
                                    ref="reviewerid"
                                    :rules="[rules.required]"
                                    v-model="formData.reviewerid"
                                    dense
                                    :items="staffList"
                                ></v-autocomplete>
                            </v-row>
                            <v-row>
                                <v-col cols="11" sm="11" class="pb-n5 mt-n8">
                                    <v-file-input 
                                        ref="attach"
                                        :label="formData.attach ? 'Reference: ' + formData.attachname : 'No file selected'" 
                                        outlined 
                                        v-model="fileHolder"
                                        @change="fileToBase64('formData')"
                                        dense
                                    ></v-file-input>
                                </v-col>
                                <v-col cols="1" sm="1" class="pb-n5 mt-n4">
                                    <v-icon
                                        class="ml-2"
                                        @click="deleteItemHandler"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </v-col>
                            </v-row>
                            <!--Add Progress Comment-->
                            <v-dialog v-model="testdialog" max-width="500px">
                                <v-card>
                                    <v-card-title>
                                        {{$t('performancemanagement.addkpicommentprogress')}}
                                    </v-card-title>
                                    <v-card-text class="pt-4">
                                        <v-container>
                                            <div>
                                                <v-row class="pb-n4 mt-n2">
                                                    <v-col cols="12" class="ml-0 pl-0">
                                                        <v-textarea
                                                            outlined
                                                            :label="$t('performancemanagement.comments')"
                                                            type="text"
                                                            :rules="[rules.required]"
                                                            v-model="progressCommentData.comments"
                                                            dense
                                                        ></v-textarea>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="pb-n4 mb-4 mt-n8">
                                                    <v-col cols="12" class="ml-0 pl-0">
                                                        <v-autocomplete
                                                            outlined
                                                            :label="$t('performancemanagement.commentby')"
                                                            type="text"
                                                            ref="commentby"
                                                            :rules="[rules.required]"
                                                            v-model="progressCommentData.commentby"
                                                            dense
                                                            :items="staffList"
                                                        ></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-text v-if="isErr" class="mt-n12">
                                        <span style="font-weight: bold; color: red">{{errMsg}}</span>
                                    </v-card-text>

                                    <v-card-actions class="mt-n10">
                                    <v-spacer></v-spacer>
                                    <v-btn color="green darken-1" text @click="saveProgressComment">{{$t('button.save')}}</v-btn>
                                    <v-btn color="red darken-1" text @click="closeProgressComment">{{$t('button.cancel')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-row class="mt-4 ml-2">
                                <v-row class="blue--text">
                                    <span style="align-content: center;" >{{$t('performancemanagement.commentshistory')}}</span>
                                    <v-btn small class="ml-5" color="primary" dark @click="openProgressComment">+</v-btn>
                                </v-row>
                            </v-row>
                            <!--Edit Progress Comment-->
                            <v-dialog v-model="editcommentdialog" max-width="500px">
                                <v-card>
                                    <v-card-title>
                                        {{$t('performancemanagement.editkpiprogesscomment')}}
                                    </v-card-title>
                                    <v-card-text class="pt-4">
                                        <v-container>
                                            <div>
                                                <v-row class="pb-n4 mt-n2">
                                                    <v-col cols="12" class="ml-0 pl-0">
                                                        <v-textarea
                                                            outlined
                                                            :label="$t('performancemanagement.comments')"
                                                            type="text"
                                                            :rules="[rules.required]"
                                                            v-model="editComment.comments"
                                                            dense
                                                        ></v-textarea>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="pb-n4 mb-4 mt-n8">
                                                    <v-col cols="12" class="ml-0 pl-0">
                                                        <v-autocomplete
                                                            outlined
                                                            :label="$t('performancemanagement.commentby')"
                                                            type="text"
                                                            ref="commentsby"
                                                            :rules="[rules.required]"
                                                            v-model="editComment.commentby"
                                                            dense
                                                            :items="staffList"
                                                        ></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-text v-if="isErr" class="mt-n12">
                                        <span style="font-weight: bold; color: red">{{errMsg}}</span>
                                    </v-card-text>

                                    <v-card-actions class="mt-n10">
                                    <v-spacer></v-spacer>
                                    <v-btn color="red darken-1" text @click="DeleteCommentInput(editComment)">{{$t('button.delete')}}</v-btn>
                                    <v-btn color="green darken-1" text @click="saveEditCommentInput">{{$t('button.save')}}</v-btn>
                                    <v-btn color="yellow darken-1" text @click="closeEditCommentInput">{{$t('button.cancel')}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-row v-if="progressCommentCard" class="mt-9 ml-n5">
                                <v-col v-for="(comment) in progressCommentList" :key="comment.id" cols="4">
                                    <v-card class="card-custom">
                                        <v-card-text>
                                            <div>
                                                <v-row class="mx-1 blue--text">
                                                    <v-col cols="9">
                                                        <p style="font-size: 14px;">{{ findStaffName(comment.commentby) }}</p>
                                                    </v-col>
                                                    <v-col cols="3">
                                                        <v-avatar @click="openEditProgressComment(comment)" size="25" tile style="cursor: pointer;">
                                                            <img
                                                            :src="`${publicPath}images/orange_pencil.svg`"
                                                            />
                                                        </v-avatar>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="mx-1 mb-2 ml-4 mt-n6">
                                                    <p style="font-size: 14px;">{{comment.comments}}</p>
                                                </v-row>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>

                        </div>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>
            <!--Progress Review Buttons-->
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="yellow darken-1" text @click="deleteHandler">{{$t('button.delete')}}</v-btn>
                <v-btn color="green darken-1" text @click="saveProgressReview">{{$t('button.save')}}</v-btn>
                <v-btn color="red darken-1" text @click="closeProgressReview">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--Progress Review Box-->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div class="kpi-card-header">
                        <div class="kpi-card-top">
                            <span class="kpi-card-type">
                                <span v-if="formData.isGenerated == 1" style="margin-right: 4px;">*</span>
                                {{$t('pmreviewexercisesectioncard.progressreview')}}
                            </span>
                            <span class="kpi-card-weightage">{{formData.reviewdate}}</span>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-card class="mb-2">
                        <div class="mx-4 mt-2">
                            <v-row class="pb-n4 pl-0 ml-0">
                                <v-col cols="3" class="ml-0 pl-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.reviewdate')"
                                        type="date"
                                        v-model="formData.reviewdate"
                                        dense
                                        class="v-input"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="8">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.reviewedby')"
                                        type="text"
                                        ref="reviewerid"
                                        v-model="formData.reviewerid"
                                        dense
                                        :items="staffList"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-autocomplete>
                                </v-col>

                                <v-col cols="1" sm="1" class="pb-n5 d-flex align-start justify-end pr-4 pt-3">
                                    <v-icon
                                        medium
                                        class="edit-icon-btn"
                                        @click="modifyItemHandler"
                                    >
                                        mdi-pen
                                    </v-icon>
                                </v-col>
                            </v-row>

                            <v-row class="pb-n4 mt-n8 pl-0 ml-0">
                                <v-col cols="3" class="ml-0 pl-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.achievement')"
                                        type="number"
                                        v-model="formData.achievement"
                                        dense
                                        class="v-input"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="2">
                                    <v-text-field
                                        outlined
                                        :label="formData.basedonpercentage ? $t('pmreviewexercisesectioncard.progressInPercentage') : $t('pmreviewexercisesectioncard.progress')"
                                        type="number"
                                        v-model="formData.progress"
                                        dense
                                        class="v-input"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row v-if="formData.attach" class="pb-n4 mt-n8 pl-0 ml-0">
                                <v-col cols="3" class="ml-0 pl-0">
                                    <p style="font-size: 0.75rem;"> <b>{{ $t('recstaffdetails.attachment') }}</b> - 
                                        <a v-bind:href="this.formData.attach"  v-bind:download="this.formData.attachname">
                                            {{formData.attachname}}
                                        </a>
                                    </p>
                                </v-col>
                            </v-row>

                            <v-row v-if="progressCommentCard" class="pb-0 mb-2 mt-0 pl-0 ml-0">
                                <v-col cols="12" class="mx-2 pl-0 mb-2">
                                    <h4 class="blue--text">{{$t('performancemanagement.comments')}}</h4>
                                </v-col>
                                
                                <v-col 
                                    v-for="(comment, index) in progressCommentList" 
                                    :key="comment.id" 
                                    cols="12" 
                                    class="mx-2 pl-0" 
                                    :style="index === progressCommentList.length - 1 ? 'margin-bottom: 1rem;' : 'padding-bottom: 0.1rem;'">
                                    <p style="margin-bottom: 0.1rem; line-height: 1.2; font-size:12px;">
                                        {{ index + 1 }}. {{ findStaffName(comment.commentby) }} - {{ comment.comments }}
                                    </p>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div v-if="isErr">  
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                ...this.parentObject.progressReviewData,
                calcmethod: this.parentObject.indKpiData.pmcalmethodid,
                basedonpercentage: this.parentObject.indKpiData.basedonpercentage,
                userid: this.$store.getters.userId,
            },
            progressCommentData: {
                kpiexerindkpiprgid: this.parentObject.progressReviewData.id,   
                commentby: this.parentObject.progressReviewData.reviewerid,
                comments: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            progressCommentList: [],
            progressCommentCard: false,

            reviewdate: this.parentObject.progressReviewData.reviewdate,
            staffList: [],
            staffid: this.parentObject.staffid,
            indKpiData: this.parentObject.indKpiData,
            editComment: {
                commentby: this.parentObject.progressReviewData.reviewerid,
                comments: null,
            },

            testdialog: false,
            editcommentdialog: false,
            ratingdialog: false,
         
            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
        }
    },

    watch: {
        // Watch for changes in achievement and calculate progress
        'formData.achievement'(newValue) {
            if (newValue) {
                //If based on percentage, use normal way. Else, use achievement as progress
                if (this.formData.basedonpercentage) {
                    if (this.formData.calcmethod == 1){ //Achievement/Target
                        this.formData.progress = (newValue / this.indKpiData.target) * 100; 
                    }else if(this.formData.calcmethod == 2){ //Target/Achievement
                        this.formData.progress = ( this.indKpiData.target / newValue) * 100; 
                    }
                }else{
                    this.formData.progress = newValue; //Direct input
                }
            } else {
                this.formData.progress = 0;
            }
        }
    },

    methods: {
        findStaffName(staffid) {
            const staff = this.staffList.find(staff => staff.value === staffid);
            return staff ? staff.text : 'Unknown'; // Return 'Unknown' if not found
        },

        loadStaffList() {
            const vm = this;
            const today = new Date();

            this.$store.dispatch('get', { url: "/staff/all/" + this.$store.getters.userId })
                .then((res) => {

                    const staffRecords = res.data.rec;

                    // Filter staff records where cessadate > today's date
                    const filteredStaff = staffRecords.filter(staff => {
                        const cessadate = new Date(staff.cessadate);
                        return cessadate > today && staff.id !== this.staffid;
                    });

                    vm.staffFull = filteredStaff;

                    // Populate staffList with filtered data
                    vm.staffList = filteredStaff.map(staff => ({
                        text: staff.psndetails,
                        value: staff.id,
                    }));

                }).catch((err) => {
                    console.error(err);
                });

        },
      
        modifyItemHandler() {
            this.ratingdialog = true;
        },

        openProgressComment() {
            this.testdialog = true;
        },

        openEditProgressComment(comment) {
            this.editComment = comment;
            this.editcommentdialog = true;
        },

        saveProgressReview() { //For Edit
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                return false;
            }

            console.log("formData AFTER SAVE", vm.formData);

            this.$store.dispatch('put', {url: "/kpiindividual/progressreview/" + vm.formData.id, payload: vm.formData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                    this.resetSelections();
                    this.ratingdialog = false;
                } else {
                    vm.reviewdate = vm.formData.reviewdate;
                    vm.$emit('edit-progress-review', vm.formData);
                    this.ratingdialog = false;
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        deleteHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }
            if (confirm(this.$t('performancemanagement.deleteprogressreview', { date: this.formData.reviewdate }))) {
                this.$store
                .dispatch('delete', { url: "/kpiindividual/progressreview/" + this.formData.id })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                        this.resetSelections();
                        this.ratingdialog = false;
                    } else {
                        this.ratingdialog = false;
                        vm.$emit('reload-progress-review-ind'); 
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }
        },

        saveProgressComment() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                return false;
            }


            this.$store.dispatch('post', {url: "/kpiindividual/progressreview/comment/create/", payload: vm.progressCommentData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                    this.closeProgressComment();
                } else {
                    const newComment = res.data.result;  

                    console.log("newcomment", newComment);

                    vm.progressCommentList.push({
                        id: newComment.id, 
                        kpiexerindkpiprgid: newComment.kpiexerindkpiprgid, 
                        commentby: newComment.commentby, 
                        comments: newComment.comments,
                        stamp: newComment.stamp,
                    });

                    this.loadProgressCommentList();
                    this.closeProgressComment();
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        loadProgressCommentList() {
            const vm = this;

            this.$store.dispatch('get', { url: "/kpiindividual/progressreview/comment/" + vm.progressCommentData.kpiexerindkpiprgid })
            .then((res) => {
                vm.progressCommentList = res.data.rec;
                if (vm.progressCommentList.length > 0) {
                    vm.progressCommentCard = true;
                }
            }).catch((err) => {
                console.error(err);
            });
        },

        saveEditCommentInput() {

            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                return false;
            }

            this.$store.dispatch('put', {url: "/kpiindividual/progressreview/comment/" + vm.editComment.id, payload: vm.editComment})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                    this.resetSelections();
                    this.editcommentdialog = false;
                } else {
                    // update the element in the array with the same id 
                    const index = this.progressCommentList.findIndex(comment => comment.id === vm.editComment.id);
                    if (index !== -1) {
                        this.$set(this.progressCommentList, index, { ...vm.editComment });
                    }
                    this.editcommentdialog = false;
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
      
        },

        DeleteCommentInput(comment){

            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('performancemanagement.delete', { code: comment.comments }))) {
                this.$store.dispatch('delete', {
                    url: "/kpiindividual/" + comment.id
                })
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    //Remove from array
                    const itemIndex = this.progressCommentList.findIndex(item => item.id === comment.id);
                    if (itemIndex !== -1) {
                        this.progressCommentList.splice(itemIndex, 1);
                    }   
                    this.editcommentdialog = false;
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }

        },

        closeProgressReview() {
            this.ratingdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;
            // reset the form fields
            this.resetSelections();
        },

        closeProgressComment() {
            this.testdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;

            // reset the form fields
            this.resetSelections();
        },

        closeEditCommentInput() {
            this.editcommentdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.formData = {
                ...this.parentObject.progressReviewData,
                calcmethod: this.parentObject.indKpiData.pmcalmethodid,
                userid: this.$store.getters.userId,
            };

            this.progressCommentData = {
                kpiexerindkpiprgid: this.parentObject.progressReviewData.id,
                commentby: this.parentObject.progressReviewData.reviewerid,
                comments: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            };
            this.editComment = {
                commentby: this.parentObject.progressReviewData.reviewerid,
                comments: null,
            };
        },
        
        deleteItemHandler() {
          this.formData.attach = ''
          this.formData.attachname = ''
        },

        fileToBase64() {
          if (this.fileHolder) {
            var file = this.$refs.attach.internalValue;
                this.formData.attachname = this.fileHolder.name
            
            var reader = new FileReader();

            reader.onloadend = () => {
                //var b64 = reader.result.replace(/^data:.+base64,/, '');
                var b64 = reader.result;
                  this.formData.attach = b64
            }

            reader.readAsDataURL(file);
          } else {
                this.formData.attach = null
          }
        },
    },

    mounted() {
        this.loadStaffList();
        this.loadProgressCommentList();
    }
}
</script>

<style scoped>

.kpi-card-header {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    padding-right: 8px;
}

.kpi-card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.kpi-card-type {
    font-size: 0.82rem;
    font-weight: 600;
    color: #37474f;
}

.kpi-card-weightage {
    font-size: 0.82rem;
    color: #546e7a;
    text-align: right;
}

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.edit-icon-btn {
    color: #4F6BFF !important;
    background: #EEF2FF;
    border-radius: 8px;
    padding: 6px;
    transition: all 0.15s;
}

.edit-icon-btn:hover {
    background: #4F6BFF !important;
    color: #fff !important;
}

.v-icon.v-icon::after {
    background-color: transparent !important;
}

.card-custom {
    border: 1px solid black;
}
</style>